export const FETCH_BTC_PRICE_DATA_SUCCESS = "FETCH_BTC_PRICE_DATA_SUCCESS";
export const FETCH_BTC_PRICE_DATA_FAILURE = "FETCH_BTC_PRICE_DATA_FAULURE";
export const FETCH_ACCOUNT_VALUE_SUCCESS = "FETCH_ACCOUNT_VALUE_SUCCESS";
export const FETCH_ACCOUNT_VALUE_FAILURE = "FETCH_ACCOUNT_VALUE_FAULURE";
export const FETCH_PROFIT_TRADES_LAST_WEEK_SUCCESS =
  "FETCH_PROFIT_TRADES_LAST_WEEK_SUCCESS";
export const FETCH_PROFIT_TRADES_LAST_WEEK_FAILURE =
  "FETCH_PROFIT_TRADES_LAST_WEEK_FAILURE";
export const FETCH_RECENT_PROFITS_SUCCESS = "FETCH_RECENT_PROFITS_SUCCESS";
export const FETCH_RECENT_PROFITS_FAILURE = "FETCH_RECENT_PROFITS_FAILURE";
export const FETCH_ALL_TIME_PROFITS_SUCCESS = "FETCH_ALL_TIME_PROFITS_SUCCESS";
export const FETCH_ALL_TIME_PROFITS_FAILURE = "FETCH_ALL_TIME_PROFITS_FAILURE";



// WEBPACK FOOTER //
// ./resources/js/store/accountValueTypes.js